export class EchantillonStatut {
    static jsonMap = {
        id: { key: 'id' },
        code: { key: 'code', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' },
        estDisponible: { key: 'estDisponible', optional: true }
    };

    public id: number;
    public code: string;
    public libelle: string;
    public estDisponible: boolean;
}
